import React from "react";
import { Col, Row } from "react-bootstrap";
import LoadPromotions from "../../../components/load-promotions/LoadPromotions";

const Promotions = () => {
  return (
    <Row className="h-100">
      <Col col={12} className="col-12 mb-4">
        <LoadPromotions />
      </Col>
    </Row>
  );
};

export default Promotions;
